import {
  customElements,
  scalarMermaid,
  scalarScript
} from "@scalar-org/guide-elements/elements";
const hydrateAll = (options) => {
  const hydrationFunctions = Object.values(customElements).map((el) => el.hydrate).filter((fn) => typeof fn === "function").concat(
    // Always include script hydration to handle any scripts in content
    [scalarScript.hydrate],
    [scalarMermaid.hydrate]
  );
  return hydrationFunctions.reduce(
    (allSucceeded, fn) => fn(options) && allSucceeded,
    true
  );
};
export {
  hydrateAll
};
//# sourceMappingURL=index.js.map
